import FavoriteVenueCard from './FavoriteVenueCard';

export default FavoriteVenueCard;
